import {
  ModalTrigger,
  SliderValue,
  SliderValueInput,
  SliderValueLabel,
  SliderValueLabelContainer,
} from "@tandemdiabetes/sugarmate-react-components"
import styles from "./NutritionDisplay.module.scss"

interface Props {
  id: string;
  label: string;
  unit: string;
  value: number | undefined;
  readOnly: boolean;
}

export function NutritionDetail(props: Props) {
  const {
    id,
    label,
    unit,
    value,
    readOnly,
  } = props

  const content = (
    <SliderValue
      className="entry-modal-nutrition-info-display-label"
      sizePreset="small"
      id={id}
    >
      <SliderValueInput
        className={styles.nutritionValue}
        value={value}
        readOnly
      />
      <SliderValueLabelContainer unit={unit}>
        <SliderValueLabel>
          {label}
        </SliderValueLabel>
      </SliderValueLabelContainer>
    </SliderValue>
  )

  return readOnly ? content : (
    <ModalTrigger asChild>
      {content}
    </ModalTrigger>
  )
}
